
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 486.97 575.82","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M92.235 556.472a72.034 72.034 0 01-6.261-.398c-17.925-1.877-35.106-10.465-47.172-23.886-2.867-3.132-5.578-6.72-7.777-10.174-7.564-11.842-11.773-25.86-11.6-39.935-.212-16.16-.046-32.322-.1-48.481l.008-161.076 224.26-243.94c74.676 81.314 149.357 162.635 224.022 243.94-.033 71.562.048 143.13-.198 214.688-1.475 22.799-14.187 44.58-33.37 57.01a75.177 75.177 0 01-29.36 11.37c-.875.13-2.11.31-3.01.407a71.639 71.639 0 01-4.568.378 75.343 75.343 0 01-7.622-.006 74.924 74.924 0 01-13.46-1.959 73.82 73.82 0 01-9.286-2.88c-13.415-5.076-25.25-14.175-33.623-25.818-8.888-12.223-14.044-27.198-14.124-42.341-.287-11.446.031-22.896-.088-34.343-.058-32.364.097-64.73-.277-97.093-.947-16.08-7.68-31.605-18.094-43.817-8.605-10.085-19.929-17.82-32.483-22.093-19.758-6.812-42.38-5.079-60.692 5.086-19.318 10.534-33.727 29.846-37.833 51.516-1.713 8.382-1.598 16.978-1.495 25.49.032 28.374.01 56.748-.035 85.122-.061 11.58-.039 23.166-.25 34.743-1.677 23.894-15.948 46.439-36.699 58.357a74.112 74.112 0 01-21.472 8.393 73.503 73.503 0 01-17.347 1.728z","fill":"none"}})])
          )
        }
      }
    